import React from 'react';
import Menu from 'fuse-ui/components/Menu';
import PropTypes from 'prop-types';

class CustomMenu extends React.Component{
  state = {
      popoverAnchor: null,
  }

  handlePopoverOpen = ( event ) => {
      this.setState( { popoverAnchor: event.currentTarget } );
  }

  handlePopoverClose = () => {
      this.setState( { popoverAnchor: null } );
  }

  render(){
      const { popoverAnchor } = this.state;
      const {  children, MenuTriggerComponent, alignment, width } = this.props;
      const fixedWidth = width ? `${width}px` : null;

      let MenuTrigger = React.cloneElement( MenuTriggerComponent, { onClick: this.handlePopoverOpen } );

      return (
          <>
              { MenuTrigger }
              <Menu
                  alignment={alignment}
                  anchorEl={popoverAnchor}
                  open={Boolean( popoverAnchor )}
                  onClose={this.handlePopoverClose}
                  width={fixedWidth}
              >
                  {
                      React.Children.map( children, ( child ) => child )
                  }
              </Menu>
          </>
      );
  }
}

CustomMenu.propTypes = {
    alignment: PropTypes.string,
    children: PropTypes.node.isRequired,
    MenuTriggerComponent: PropTypes.node.isRequired,
    width: PropTypes.number,
};

CustomMenu.defaultProps = {
    alignment: 'right'
};

export default CustomMenu;
